import { render, staticRenderFns } from "./HotSearch.vue?vue&type=template&id=fd8bb382&scoped=true&"
import script from "./HotSearch.vue?vue&type=script&lang=js&"
export * from "./HotSearch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd8bb382",
  null
  
)

export default component.exports